import * as Yup from 'yup'
import { login_msg } from '../../../msg/msg'

export const mypageDefaultSchema = Yup.object().shape({
    user_name: Yup.lazy((value) =>
        value
            ? Yup.string()
                .max(40, login_msg.nameMaxLengthError)
            : Yup.string().notRequired()
    ),
    tel: Yup.lazy((value) =>
        value
            ? Yup.string()
                .matches(/^\d{10,11}$/, login_msg.telError)
            : Yup.string().notRequired()
    ),
})

export const passwordSchema = Yup.object().shape({
    password: Yup.string()
        .required('비밀번호는 필수 입력 항목입니다.')
        .min(8, '비밀번호는 최소 8자 이상이어야 합니다.')
        .matches(
            /^[a-zA-Z0-9!@#$%^&*]*$/,
            '비밀번호에 허용되지 않은 문자가 포함되어 있습니다.',
        ),
    newPassword: Yup.string()
        .required('비밀번호는 필수 입력 항목입니다.')
        .min(8, '비밀번호는 최소 8자 이상이어야 합니다.')
        .matches(
            /^[a-zA-Z0-9!@#$%^&*]*$/,
            '비밀번호에 허용되지 않은 문자가 포함되어 있습니다.',
        )
        .notOneOf(
            [Yup.ref('password')],
            '새 비밀번호는 현재 비밀번호와 같을 수 없습니다.',
        ),
    newPasswordCheck: Yup.string()
        .required('비밀번호는 필수 입력 항목입니다.')
        .min(8, '비밀번호는 최소 8자 이상이어야 합니다.')
        .matches(
            /^[a-zA-Z0-9!@#$%^&*]*$/,
            '비밀번호에 허용되지 않은 문자가 포함되어 있습니다.',
        )
        .oneOf(
            [Yup.ref('newPassword')],
            '새 비밀번호 확인이 새 비밀번호와 일치하지 않습니다.',
        ),
})